const burgerBtn = document.querySelector('.burger');
const mobileMenu = document.querySelector('.mobile-menu');
const closeBtn = mobileMenu.querySelector('.modal-window-close-btn');
const mobileLinks = mobileMenu.querySelectorAll('a');
const buyBtns = document.querySelectorAll('.btn-buy, .btn-buy-mobile'); 
const body = document.body;

// const clickEscPress = event => {
//   if (event.code === 'Escape') {
//     closeModal();
//   }
// };

// const clickBackdropClick = event => {
//   if (event.target === mobileMenu) {
//     closeModal();
//   }
// };

// export const openMenu = () => { 
//   console.log("open");
  
//   mobileMenu.classList.add('is-open');
//   document.body.style.overflow = 'hidden';
//   window.addEventListener('keydown', clickEscPress);
//   mobileMenu.addEventListener('click', clickBackdropClick);
// };

// export const closeMenu = () => {
//   console.log("close");
//   mobileMenu.classList.remove('is-open');
//   document.body.style.overflow = '';
//   window.removeEventListener('keydown', clickEscPress);
//   mobileMenu.removeEventListener('click', clickBackdropClick);     
// };




// burgerBtn.addEventListener('click', openMenu);
// closeBtn.addEventListener('click', closeMenu);




const clickEscPress = event => {
  if (event.code === 'Escape') {
    closeMenu();
  }
};

const clickBackdropClick = event => {
  if (event.target === mobileMenu) {
    closeMenu();
  }
};









function openMenu() {
  mobileMenu.classList.add('is-open');
  burgerBtn.setAttribute('aria-expanded', 'true');
  body.style.overflow = 'hidden';
  window.addEventListener('keydown', clickEscPress);
    mobileMenu.addEventListener('click', clickBackdropClick);
  // burgerBtn.focus(); // фокус на кнопку бургер (опційно)
}

function closeMenu() {
  mobileMenu.classList.remove('is-open');
  burgerBtn.setAttribute('aria-expanded', 'false');
  body.style.overflow = '';
  window.removeEventListener('keydown', clickEscPress);
    mobileMenu.removeEventListener('click', clickBackdropClick);
  

  // if (document.activeElement) {
  //   document.activeElement.blur();
  // }
 
  // body.focus({ preventScroll: true });
}

burgerBtn.addEventListener('click', openMenu);
closeBtn.addEventListener('click', closeMenu);

mobileMenu.addEventListener('click', e => {
  if (e.target === mobileMenu) closeMenu();
});

document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMenu();
});

mobileLinks.forEach(link => {
  link.addEventListener('click', () => closeMenu());
});

buyBtns.forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    closeMenu();
    const furnitureSection = document.querySelector('#furniture') || document.querySelector('#furniture-list');
    if (furnitureSection) {
      furnitureSection.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

const logoLink = document.querySelector('.header-logo');
if (logoLink) {
  logoLink.addEventListener('click', e => {
    e.preventDefault();
    closeMenu();
    const heroSection = document.querySelector('#hero');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = 'index.html';
    }
  });
}


body.setAttribute('tabindex', '-1');
